import React, { useEffect, useState } from 'react';
import Selection from '../../selection';

function Employment(props) {
    const [display, setDisplay] = useState(displayPage())

    useEffect(() => {
        setDisplay(displayPage())
    }, [props.page, props.store])

    function displayPage() {
        switch (props.page) {
            case 7:
                return (
                    <Selection prev={props.prev} setPrev={props.setPrev} store={props.store} setPage={props.setPage} page={{
                        heading: "What’s your current employment status?",
                        content: "This will have an impact on the other financial details we’ll need.",
                        buttons: {
                            "Employed": {
                                value: "EMPLOYED",
                                next: 8
                            },
                            "Self employed": {
                                value: "SELF_EMPLOYED",
                                next: 11
                            },
                            "Company director": {
                                value: "COMPANY_DIRECTOR",
                                next: 15
                            },
                            "Contractor": {
                                value: "CONTRACTOR",
                                next: 21
                            },
                            accordion: {
                                id: "employment",
                                phrase: "See more options",
                                alt: "See less options",
                                buttons: {
                                    "Retired": {
                                        value: "RETIRED",
                                        next: 22
                                    },
                                    "Homemaker": {
                                        value: "HOMEMAKER",
                                        next: 22
                                    },
                                    "Student": {
                                        value: "STUDENT",
                                        next: 22
                                    },
                                    "Unemployed": {
                                        value: "UNEMPLOYED",
                                        next: 22
                                    }
                                }
                            }
                        },
                    }} id={"employment"} setValue={(e) => props.setValue({ ...props.store, employment: e })} />
                )
        }
    }

    return (
        <div>
            {display}
        </div>
    );
}

export default Employment;